import type { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

interface LegalPageProps {
  title: string;
  updated: string;
  children: ReactNode;
}

export function LegalPage({ title, updated, children }: LegalPageProps) {
  return (
    <div style={{ background: "#FAFAF8", minHeight: "100vh", fontFamily: "var(--font-body)" }}>
      <Navbar variant="minimal" alwaysSolid />
      <div className="container" style={{ maxWidth: 800, margin: "0 auto", padding: "110px 24px 90px" }}>
        <h1 style={{
          fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
          color: "var(--ink)", letterSpacing: "-0.02em", margin: "0 0 8px",
        }}>
          {title}
        </h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, marginBottom: 48 }}>
          Última actualización: {updated}
        </p>
        {children}
      </div>
      <Footer />
    </div>
  );
}

interface LegalSectionProps {
  title: string;
  children: ReactNode;
}

export function LegalSection({ title, children }: LegalSectionProps) {
  return (
    <section style={{ marginBottom: 44 }}>
      <h2 style={{
        fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 20,
        color: "#C49A8A", margin: "0 0 14px",
      }}>
        {title}
      </h2>
      <div style={{ color: "#4A4A4A", fontSize: 15.5, lineHeight: 1.8 }}>
        {children}
      </div>
    </section>
  );
}
